import { useEffect, useMemo } from 'react';

/** Превью файла, которое само освобождается при замене и уходе со страницы. */
export function useObjectUrl(file: Blob | null): string {
  const url = useMemo(() => (file ? URL.createObjectURL(file) : ''), [file]);
  useEffect(() => () => {
    if (url) URL.revokeObjectURL(url);
  }, [url]);
  return url;
}
